import { BaseService } from "../base/BaseService";
import { ILogService } from "./ILogService";
import { ILogRepository } from "./ILogRepository";
import { LogLevel } from "./LogLevel";

export class LogService extends BaseService implements ILogService {
    private logRepository: ILogRepository;
    constructor() {
        super();
        this.logRepository = this.dependencies.logRepository;
    }
    log(level: LogLevel, message: string, exception?: any): void {
        this.logRepository.log(level, message, exception);
    }
}
